
const ANIME_URL = process.env.REACT_APP_ANIME_URL


export default ANIME_URL